// Configuration for welcome modal videos by user role
// Each role has an array of video GUIDs that will be fetched from the API
const WELCOME_MODAL_CONFIGS = {
    educator: {
        slides: [
            { videoGuid: 'c9443838-09a6-416e-8afc-cfd464c4ec42' },
            { videoGuid: '66c25438-8e5a-4ebc-8aa3-b21c840279ff' },
            { videoGuid: '6627df72-3cc7-4521-a0b8-40a8e0a1fbc3' },
            { videoGuid: '06f4acf6-b5f6-49e2-bad6-98d20adc0b1d' },
        ],
    },
    employee: {
        slides: [
            { videoGuid: '7774d05f-260b-415b-9589-22b62f5e84d1' },
            { videoGuid: 'a3a72119-d878-41c3-9336-29a945c3e5c5' },
            { videoGuid: '5abd67d7-10a0-493a-b532-e0bebb1968c8' },
            { videoGuid: 'e657b0d3-f3dd-4d67-81f3-deda4f031b87' },
        ],
    },
};

export default function getWelcomeModalConfig(role) {
    return WELCOME_MODAL_CONFIGS[role] || null;
}
